import { render } from "./NavBarBrandIcon.vue?vue&type=template&id=da0e1546&lang=html&bindings={\"icon\":\"props\",\"url\":\"props\",\"color\":\"props\"}"
import script from "./NavBarBrandIcon.vue?vue&type=script&lang=ts"
export * from "./NavBarBrandIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script